import { Component } from "react";
import CircleButton from "../CircleButton";
import {ReactComponent as EditIc} from "../../../assets/icons/edit-ic.svg";

class EditButton extends Component {    

    render() {
        return (
            <>                
                <CircleButton icon={<EditIc/>} onClick={this.props.onClick} />
            </>
        )
    }
}

export default EditButton;